import React from 'react';
import { useState, useEffect } from 'react';
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
//import TableCell from '@mui/material/TableCell';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const LanguageClass = () => {

  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('./language-class-intro.html') // Path relative to public folder
      .then(response => response.text())
      .then(data => setContent(data));
  }, []);


  return (
    <>

        <Box height={100} />

          <Grid container spacing={0} alignItems="center" justify="center">
                <Grid item xs={2} />
                <Grid item xs={8}>
                    <Card>
                    <CardHeader title='中文语言课'/>
                    <CardContent>
                      <Box textAlign={'center'}>
                        <Box textAlign={'center'}>
                          <Link href={`/documents/Chinese_courses_description.pdf`} color="primary" underline="none">
                            中文语言课介绍/Chinese Courses Description (PDF Download)
                          </Link>
                        </Box>
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                      </Box>

                    </CardContent>
                    </Card>

                </Grid> 
                <Grid item xs={2} />
          </Grid>
      
        <Grid container spacing={0} alignItems="center" justify="center">
              <Grid item xs={2} />

              <Grid item xs={8}>
                  <Card>
                  <CardHeader sx={{color: 'primary.main'}} title='三角区中文学校2026-2027学年秋季中文语言目录'/>
                  <CardContent>
                    <Box textAlign={'center'}>
                      <TableContainer component={Paper}>
                        <Table 
                          sx={{
                            [`& .${tableCellClasses.root}`]: {
                              borderRight: '1px solid rgba(224, 224, 224, 1)', // Adds vertical lines
                            },
                            [`& .${tableCellClasses.root}:last-child`]: {
                              borderRight: 'none', // Prevents border on the very right edge
                            },
                          }}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{background: 'lightgray',fontWeight: 'bold'}}>班级</TableCell>
                              <TableCell sx={{background: 'lightgray',fontWeight: 'bold'}}>教师姓名</TableCell>
                              <TableCell sx={{background: 'lightgray',fontWeight: 'bold'}}>上课时间</TableCell>
                              <TableCell sx={{background: 'lightgray',fontWeight: 'bold'}}>教室</TableCell>
                              <TableCell sx={{background: 'lightgray',fontWeight: 'bold'}}>班级容量</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_csl.pdf`} color="primary" underline="none" target="_blank">
                                  CSL 
                                </Link>
                                </TableCell>
                              <TableCell>杨爱灵</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>1235</TableCell>
                              <TableCell>10</TableCell>
                            </TableRow>
                             <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_prek.pdf`} color="primary" underline="none" target="_blank">
                                  PreK 
                                </Link>
                                </TableCell>
                              <TableCell>王静</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>1214</TableCell>
                              <TableCell>30</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_kindergarden.pdf`} color="primary" underline="none" target="_blank">
                                  KA 
                                </Link>
                                </TableCell>
                              <TableCell>张释予</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>1205</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_kindergarden.pdf`} color="primary" underline="none" target="_blank">
                                  KB 
                                </Link>
                                </TableCell>
                              <TableCell>周雁</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>1207</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade1.pdf`} color="primary" underline="none" target="_blank">
                                  1A
                                </Link>
                                </TableCell>
                              <TableCell>李淑静</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>1202</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade1.pdf`} color="primary" underline="none" target="_blank">
                                  1B
                                </Link>
                                </TableCell>
                              <TableCell>拉姆</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>1204</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade2.pdf`} color="primary" underline="none" target="_blank">
                                  2A
                                </Link>
                                </TableCell>
                              <TableCell>刘姝</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>1219</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade2.pdf`} color="primary" underline="none" target="_blank">
                                  2B
                                </Link>
                                </TableCell>
                              <TableCell>刘秀兰</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>1212</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade3.pdf`} color="primary" underline="none" target="_blank">
                                  3A
                                </Link>
                                </TableCell>
                              <TableCell>于丽红</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>2212</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade3.pdf`} color="primary" underline="none" target="_blank">
                                  3B
                                </Link>
                                </TableCell>
                              <TableCell>刘彦</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>2210</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade4.pdf`} color="primary" underline="none" target="_blank">
                                  4A
                                </Link>
                                </TableCell>
                              <TableCell>郭蔚雯</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>2214</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade4.pdf`} color="primary" underline="none" target="_blank">
                                  4B
                                </Link>
                                </TableCell>
                              <TableCell>丁伟</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>2216</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade5.pdf`} color="primary" underline="none" target="_blank">
                                  5A
                                </Link>
                                </TableCell>
                              <TableCell>王兆君</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>2209</TableCell>
                              <TableCell>18</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade6.pdf`} color="primary" underline="none" target="_blank">
                                  6A
                                </Link>
                                </TableCell>
                              <TableCell>李磊</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>2204</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade6.pdf`} color="primary" underline="none" target="_blank">
                                  6B
                                </Link>
                                </TableCell>
                              <TableCell>田春梅</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>2206</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade7.pdf`} color="primary" underline="none" target="_blank">
                                  7A
                                </Link>
                                </TableCell>
                              <TableCell>于国威</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>2208</TableCell>
                              <TableCell>18</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade8.pdf`} color="primary" underline="none" target="_blank">
                                  8A
                                </Link>
                                </TableCell>
                              <TableCell>张坤</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>2203</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_grade9.pdf`} color="primary" underline="none" target="_blank">
                                  9A
                                </Link>
                                </TableCell>
                              <TableCell>廖伟莹</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>2205</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/cn_class_ap.pdf`} color="primary" underline="none" target="_blank">
                                  AP
                                </Link>
                                </TableCell>
                              <TableCell>周米亚</TableCell>
                              <TableCell>9:15-11:00 am， Sat</TableCell>
                              <TableCell>TBD</TableCell>
                              <TableCell>10</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>

                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                >
                                  教务长
                                </Typography>

                                </TableCell>
                              <TableCell>杨晨敏</TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                >
                                  办公室
                                </Typography>
                                </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell>1220</TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                >
                                  家长休息室
                                </Typography>
                                </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell>1247</TableCell>
                              <TableCell></TableCell>
                            </TableRow>                                                                                    

                          </TableBody>
                        </Table>
                      </TableContainer>

                    </Box>

                  </CardContent>
                  </Card>

              </Grid> 

              <Grid item xs={2} />
        </Grid>

      <Box sx={{ height: '80px' }}></Box>
    </>
  )
}

export default LanguageClass